import {
  hasValue,
  isValidEthAddress
} from './rules'

export type Validator = (value: any) => [boolean, string]

export type ValidatorBuilder = (...args: any[]) => Validator

export const requiredValidator: Validator = (value) => [hasValue(value), 'This field is required']

export const ethAddressValidator: ValidatorBuilder = (ensSupported: boolean = false) =>
  (value) => [
    isValidEthAddress(value, ensSupported),
    `Please provide a valid Ethereum address${ensSupported ? ' or ENS domain' : ''}`
  ]
